import { Injectable } from '@angular/core';
import { Configuration } from '../configuration';
import { HttpClient } from '@angular/common/http';
import { CrossSellingQuestionVm } from '../models/crossSellingQuestionVm.model';
import { SaveCrossSellingQuestionsCommand } from '../models/saveCrossSellingQuestionsCommand.model';
import { CrossSellingInformationVm } from '../models/crossSellingInformationVm.model';

@Injectable({
  providedIn: 'root'
})
export class CrossSellingService {
  public configuration = new Configuration();
  baseUrl: string;
  apiEndpoint: string = 'crosssellings';

  constructor(private http: HttpClient, configuration: Configuration) {
    this.baseUrl = configuration.apiBasePath ?? '';
  }

  public getQuestions(agreementId: string, salesChannel: string) {
    return this.http.get<CrossSellingInformationVm>(
      `${this.baseUrl}${this.apiEndpoint}/agreement/${agreementId}/questions/salesChannel/${salesChannel}`
    );
  }

  public patchMemberAnswers(saveCrossSellingQuestionsCommand: SaveCrossSellingQuestionsCommand) {
    return this.http.patch(
      `${this.baseUrl}${this.apiEndpoint}/answers`,
      saveCrossSellingQuestionsCommand
    );
  }
}
